import React from 'react';
import { renderIntoContainer } from 'react/root/containerRoot';

import LazyLoader from 'imports/LazyLoader.js';

// Mounts the /mod/user-bugs React page onto its shell container.
$(function() {
	const mount = $('#mod-user-bugs');
	if(!mount.length) {
		return;
	}

	LazyLoader.modUserBugs()
		.then(({ default: ModUserBugs }) => {
			renderIntoContainer(<ModUserBugs />, mount[0]);
		});
});
